<template>
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216 216" fill="currentColor">
    <path d="M116.67 63.27H85.6v89.46h10.18v-28.36h20.89a30.06 30.06 0 0 0 30-30v-1a30.06 30.06 0 0 0-30-30.1zm19.84 31.07a19.86 19.86 0 0 1-19.84 19.85H95.78V73.45h20.89a19.87 19.87 0 0 1 19.84 19.85z"/>
    <path d="M169.45 46.55A86.91 86.91 0 1 0 194.9 108a86.36 86.36 0 0 0-25.45-61.45zm-7.2 115.7A76.72 76.72 0 1 1 184.72 108a76.22 76.22 0 0 1-22.47 54.25z"/>
</svg>

</template>